import BrowserStore from 'store2';
import { createReducer } from "../utils";
import {
  ADD_USER_FAVORITE_REQUEST,
  ADD_USER_FAVORITE_SUCCESS,
  ADD_USER_FAVORITE_FAILURE,
  REMOVE_USER_FAVORITE_REQUEST,
  REMOVE_USER_FAVORITE_SUCCESS,
  REMOVE_USER_FAVORITE_FAILURE,
  FETCH_USER_FAVORITE_REQUEST,
  FETCH_USER_FAVORITE_SUCCESS,
  FETCH_USER_FAVORITE_FAILURE,
  RESET_USER_FAVORITES, TOGGLE_SNAPSHOT_FAVORITE_SUCCESS, TOGGLE_SNAPSHOT_FAVORITE, TOGGLE_SNAPSHOT_FAVORITE_FAILURE
} from '../constants';

const initialState = {
  isFetching: false,
  user: {
    livecams: null,
    snapshots: null
  },
  users: []
};

export default createReducer(initialState, {
  [ADD_USER_FAVORITE_REQUEST]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: true
    });
  },
  [ADD_USER_FAVORITE_SUCCESS]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: false,
      user: {
        livecams: [...state["user"]["livecams"], payload]
      }
    });
  },

  [ADD_USER_FAVORITE_FAILURE]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: false
    });
  },
  [REMOVE_USER_FAVORITE_REQUEST]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: true
    });
  },
  [REMOVE_USER_FAVORITE_SUCCESS]: (state, payload) => {
    const arr = [...state.user.livecams];
    const index = arr.indexOf(payload);
    if (index > -1) {
      arr.splice(index, 1);
    }

    return Object.assign({}, state, {
      isFetching: false,
      user: {
        livecams: arr
      }
    });
  },

  [REMOVE_USER_FAVORITE_FAILURE]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: false
    });
  },
  [FETCH_USER_FAVORITE_REQUEST]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: true
    });
  },

  [FETCH_USER_FAVORITE_SUCCESS]: (state, payload) => {
    BrowserStore.session.set('favorites', payload);
    return Object.assign({}, state, {
      isFetching: false,
      user: payload
    });
  },

  [FETCH_USER_FAVORITE_FAILURE]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: false,
      user: null
    });
  },
  [RESET_USER_FAVORITES]: (state, payload) => {
    return initialState;
  },

  [TOGGLE_SNAPSHOT_FAVORITE]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: true
    });
  },

  [TOGGLE_SNAPSHOT_FAVORITE_SUCCESS]: (state) => {
    return Object.assign({}, state, { isFetching: false });
  },

  [TOGGLE_SNAPSHOT_FAVORITE_FAILURE]: (state, payload) => {
    return Object.assign({}, state, {
      isFetching: false,
    });
  },
});
